/**
 * Reads the drawer's cards as a sentence: "Topic risk" based on "Inherent risk" adjusted by "Assessment result".
 */
import { Typography } from '@mui/material'
import React from 'react'

export const ConnectorLabel: React.FC<{ label: string }> = ({ label }) => (
  <Typography variant="body2" color="text.secondary" align="center">
    {label}
  </Typography>
)

export default ConnectorLabel
